import { setSectionState } from '../../../store/orders/drawer/orders.drawer.actions';
import { selectOrdersDrawerionSectionStates } from '../../../store/orders/drawer/orders.drawer.selectors';

export const mapStateToOpen = (state, sectionId) => {
  const sectionStates = selectOrdersDrawerionSectionStates(state) || {};
  const sectionState = sectionStates[sectionId] || { open: false };
  const { open } = sectionState;
  return {
    open,
  };
};

export const mapDispatchToOnClick = (dispatch, sectionId) => {
  return {
    onClick: (isOpen) => dispatch(setSectionState(sectionId, { open: !isOpen })),
  };
};
